import documentsApi from "@/api/documents-api";
import router from "@/router";

const state = {
  category: {},
  itemsCategories: [],
  totalItemsCategories: 0,
  selectCategories: [],
};

const mutations = {
  setCategory(state, val) {
    state.category = val;
  },
  setItemsCategories(state, val) {
    state.itemsCategories = val;
  },
  setTotalItemsCategories(state, val) {
    state.totalItemsCategories = val
  },
  setSelectCategories(state, val) {
    state.selectCategories = val;
  },
};

const actions = {
  async selectCategories({ commit }, { client_id = "" }) {
    commit("app/loading", true, { root: true });
    await documentsApi.list(client_id).then(
      (response) => {
        commit("setSelectCategories", response.data.data);
        commit("app/loading", false, { root: true });
      },
      () => {
        commit("app/loading", false, { root: true });
        commit(
          "notifications",
          {
            title: "Error en la búsqueda de categorías.",
            variant: "danger",
          },
          { root: true }
        );
        commit("setShowNotifications", true, { root: true });
      }
    );
  },
  async getListCategories({ commit }, { page, per_page, search = '', client_id = '', active = true}) {
    commit("app/loading", true, { root: true });
    await documentsApi.list(page, per_page, search, client_id, active).then(
      (response) => {
        commit('setItemsCategories', response.data.data)
        commit('setTotalItemsCategories', response.data.meta.total[1])
        commit("app/loading", false, { root: true });
      },
      () => {
        commit("app/loading", false, { root: true });
        commit(
          "notifications",
          {
            title: "Error al obtener el listado de departamentos.",
            variant: "danger",
          },
          { root: true }
        );
        commit("setShowNotifications", true, { root: true });
      }
    );
  },
  async getCategory({ commit }, id) {
    commit("app/loading", true, { root: true });
    await documentsApi.getCategory(id).then(
      (response) => {
        commit("setCategory", response.data.data);
        commit("app/loading", false, { root: true });
      },
      () => {
        commit("app/loading", false, { root: true });
        commit(
          "notifications",
          { title: "Error al obtener la categoría.", variant: "danger" },
          { root: true }
        );
        commit("setShowNotifications", true, { root: true });
      }
    );
  },
  editCategory({ commit }, { id, category }) {
    commit("app/loading", true, { root: true });
    documentsApi.editCategory(id, category).then(
      () => {
        commit(
          "notifications",
          { title: "Categoría actualizada con éxito.", variant: "success" },
          { root: true }
        );
        commit("setShowNotifications", true, { root: true });
        commit("app/loading", false, { root: true });
      },
      () => {
        commit("app/loading", false, { root: true });
        commit(
          "notifications",
          { title: "Error al actualizar la categoría.", variant: "danger" },
          { root: true }
        );
        commit("setShowNotifications", true, { root: true });
      }
    );
  },
  createCategory({ commit }, { category }) {
    commit("app/loading", true, { root: true });
    documentsApi.createCategory(category).then(
      () => {
        commit(
          "notifications",
          { title: "Categoría creada con éxito.", variant: "success" },
          { root: true }
        );
        commit("setShowNotifications", true, { root: true });
        router.push({ name: "categoriesDocuments" });
        commit("app/loading", false, { root: true });
      },
      () => {
        commit("app/loading", false, { root: true });
        commit(
          "notifications",
          { title: "Error al crear la categoría.", variant: "danger" },
          { root: true }
        );
        commit("setShowNotifications", true, { root: true });
      }
    );
  },
  deleteCategory({ commit }, id) {
    commit("app/loading", true, { root: true });
    documentsApi.deleteCategory(id).then(
      () => {
        commit(
          "notifications",
          { title: "Categoría eliminada con éxito.", variant: "success" },
          { root: true }
        );
        location.reload();
      },
      () => {
        commit("app/loading", false, { root: true });
        commit(
          "notifications",
          { title: "Error al eliminar la categoría.", variant: "danger" },
          { root: true }
        );
        commit("setShowNotifications", true, { root: true });
      }
    );
  },
  deleteDocument({ commit }, id) {
    commit("app/loading", true, { root: true });
    documentsApi.deleteDocument(id).then(
      () => {
        commit(
          "notifications",
          { title: "Documento eliminado con éxito.", variant: "success" },
          { root: true }
        );
        location.reload();
      },
      () => {
        commit("app/loading", false, { root: true });
        commit(
          "notifications",
          { title: "Error al eliminar el documento.", variant: "danger" },
          { root: true }
        );
        commit("setShowNotifications", true, { root: true });
      }
    );
  },
  createDocument({ commit }, document) {
    commit("app/loading", true, { root: true });
    documentsApi.createDocument(document).then(
      () => {
        commit(
          "notifications",
          { title: "Documento creado con éxito.", variant: "success" },
          { root: true }
        );
        location.reload();
        commit("app/loading", false, { root: true });
      },
      () => {
        commit("app/loading", false, { root: true });
        commit(
          "notifications",
          { title: "Error al crear el documento.", variant: "danger" },
          { root: true }
        );
        commit("setShowNotifications", true, { root: true });
      }
    );
  },
  createDocumentBulk({ commit }, document) {
    commit("app/loading", true, { root: true });
    documentsApi.createDocumentBulk(document).then(
      () => {
        commit(
          "notifications",
          { title: "Documentos creados con éxito.", variant: "success" },
          { root: true }
        );
        location.reload();
        commit("app/loading", false, { root: true });
      },
      () => {
        commit("app/loading", false, { root: true });
        commit(
          "notifications",
          { title: "Error al crear el documento.", variant: "danger" },
          { root: true }
        );
        commit("setShowNotifications", true, { root: true });
      }
    );
  },
};

const getters = {
  getCategory: state => state.category,
  getSelectCategories: state => state.selectCategories,
  getItemsCategories: state => state.itemsCategories,
  getTotalItemsCategories: state => state.totalItemsCategories,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
